/**
 * Which regional copy of the HubSpot trial form a sign-up goes to, from the visitor's country
 * (ISO 3166-1 alpha-2): the EU form for Europe and the AU form for Australia and its
 * territories, as the website's SAP Tracking script draws those lines, and the global form
 * for everyone else and when the country is unknown. Sent as the form's `region` hidden input.
 */
export type TrialRegion = 'global' | 'eu' | 'au'

const EU_COUNTRIES: ReadonlySet<string> = new Set([
  'FR', 'AD', 'AT', 'BE', 'CY', 'EE', 'FI', 'DE', 'GR', 'IE', 'IT', 'LV', 'LT', 'LU', 'MC', 'ME',
  'MT', 'NL', 'PT', 'SK', 'SI', 'SM', 'ES', 'BG', 'HR', 'CZ', 'HU', 'PL', 'RO', 'XK', 'CH', 'LI',
  'SE', 'NO', 'DK', 'GL', 'FO',
])

const AU_COUNTRIES: ReadonlySet<string> = new Set(['AU', 'CX', 'CC', 'NR', 'TV', 'KI', 'NF', 'HM'])

export function trialRegion(countryCode?: string): TrialRegion {
  const code = (countryCode || '').toUpperCase()
  if (EU_COUNTRIES.has(code)) return 'eu'
  if (AU_COUNTRIES.has(code)) return 'au'
  return 'global'
}
